module.exports = __webpack_public_path__ + "img/josiah-henson.4aa66cc9.png";